<template>
  <div style="height:100%;">
    <!--<div class='h-borderBox height-500'>-->
      <!--<div class='h-borderTree-content'>-->
        <!--<div>-->
          <!--<div class="h-dp-detail-div">{{detailInfo.serviceName}}</div>-->
          <!--<div v-show="detailShow.description">-->
            <!--<div class="h-dp-detail-div">应用介绍 </div>-->
            <!--<div class="h-dp-detail-div"><span>{{detailInfo.description}}</span></div>-->
          <!--</div>-->
          <!--<div v-show="detailShow.deliverType">-->
            <!--<div class="h-dp-detail-div">交付类型 </div>-->
            <!--<div class="h-dp-detail-div"><span>{{detailInfo.deliverType}}</span> </div>-->
          <!--</div>-->
          <!--<div v-show="detailShow.createTime">-->
            <!--<div class="h-dp-detail-div">上架时间 </div>-->
            <!--<div class="h-dp-detail-div"><span>{{detailInfo.createTime}}</span></div>-->
          <!--</div>-->
          <!--<div v-show="buttonShow" class="h-dp-detail-div-withBtn">-->
            <!--<button @click="deployFun">部署实例</button>-->
          <!--</div>-->
          <!--<div v-show="delButtonShow" class="h-dp-detail-div-withBtn-del">-->
            <!--<button @click="deleteFun">删除</button>-->
          <!--</div>-->
        <!--</div>-->
      <!--</div>-->
    <!--</div>-->
    <div class="left-box">
      <div class="left-logo"><span class="word-front ">{{detailInfo.serviceName}}</span><span class="word-behind">{{detailInfo.serviceName}}</span></div>
      <div v-for="dataItem in detailShowList">
        <div class="left-word">
          <span class="left-wordName">{{dataItem.name}}</span>
          <span class="left-wordContent" :title="dataItem.value">{{dataItem.value}}</span>
        </div>
      </div>
      <div class="left-bottom" v-show="showAll">
        <div v-show="buttonShow" class="h-dp-detail-div-withBtn">
          <!--<button @click="deployFun"></button>-->
          <ejs-button cssClass="e-btn e-control e-primary"  v-on:click.native="deployFun">{{$t('DeployManagement.deployedInstance')}}</ejs-button>
        </div>
        <div v-show="delButtonShow" class="h-dp-detail-div-withBtn-del">
          <ejs-button cssClass="e-btn e-control e-primary" v-on:click.native="deleteFun">{{$t('DeployManagement.delete')}}</ejs-button>
          <!--<button @click="deleteFun">删除</button>-->
        </div>
      </div>
    </div>
    <CustomDialog ref='singleDeploymentPage' :element='dialog.element.eleSingleDeployment' :styles='dialog.styles' :messages='dialog.messages.eleSingleDeployment'>
      <template v-slot:dialog-content>
        <SingleDeployment ref='singleDeploymentDialog' :formParams='formParamsChart' :opCode='opCode' :tabElements='tabElements'></SingleDeployment>
      </template>
    </CustomDialog>
   <CustomDialog ref="deployCasePage" :element="deployCasePage.element" :styles="deployCasePage.styles">
      <template v-slot:dialog-content>
        <DeployCaseDialog ref="deployCase"></DeployCaseDialog>
      </template>
    </CustomDialog>
    <CustomDialog ref='netElementDialog' :element='neDialog.element' :styles='neDialog.styles' :messages='neDialog.messages'>
      <template v-slot:dialog-content>
        <add-ne ref="netElement" @close='addNeCancel'></add-ne>
      </template>
    </CustomDialog>
  </div>
</template>

<script>
import { EventBus } from '../../plugins/eventBus';
import CustomDialog from '../common/CustomDialog';
import SingleDeployment from './serverManagement/SingleDeployment';
import SubscriberTool from '../subscriberconfig/util/parseFormNew/tools/subscriberTool';
import DeployCaseDialog from './serverManagement/deployCaseDialog';
import AddNe from '../topoconfig/AddNe';

export default {
  name: 'ServerDetailLeft',
  components: {
    CustomDialog,
    SingleDeployment,
    DeployCaseDialog,
    AddNe,
  },
  props: {
    deployedNum: { type: Number, default:0 },
    detailInfo: {
      type: Object,
      default() {
        return {
          serviceName: '',
          description: '',
          deliverType: '',
          createTime: '',
          pkgVersion: '',
          serviceId: -1,
        }
      }
    },
    detailShow: {
      type: Object,
      default() {
        return {
          description: false,
          deliverType: false,
          createTime: false
        }
      }
    },
    detailShowList: Array,
    buttonShow: {
      type: Boolean,
      default: false
    },
    delButtonShow: {
      type: Boolean,
      default: false
    },
    showAll: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      formParamsChart: {
        modelName: 'chart'
      },
      tabElements: {
        refName: 'xxxxx',
        items: [
        ]
      },
      opCode: 'add',
      dialog: {
        styles: {
          width: '50%',
          height: '90%',
          visible: false,
          zIndex: 1000,
          model: true
        },
        element: {
          eleSingleDeployment: {
            target: this.$refs.deployBtn,
            refName: 'eleSingleDeployment',
            buttonGroup: [
              { click: this.closeSingleDeploymentPage, buttonModel: { content: this.$t('TS.ts_ok'), isPrimary: true } },
              { click: this.closeSingleDeploymentPage, buttonModel: { content: this.$t('UE.ueCancell') } }
            ],
            title: '部署实例',
            isClose: true
          }
        },
        messages: {
          eleSingleDeployment: {
            title: '部署实例'
          }
        }
      },
      deployCasePage: {
        styles: {
          width: '60%',
          height: '90%',
          model: true,
          zIndex: 1000,
          visible: false
        },
        element: {
          refName: "deployCaseStyle",
          isClose: true,
          buttonGroup: [
            { click: this.deployDialogHide, buttonModel: { content: this.$t('Common.cancel') } },
            {click: this.sendDeploy,buttonModel: {content:'部署',isPrimary: true}}
          ],
          title: this.$t('部署实例')
        }
      },
      neDialog: {
        element: {
          title: this.$t('Topo.neAdd'),
          // target: '#app',
          isClose: true,
          refName: this.$t('Topo.neMange'),
          buttonGroup: [
            { click: this.addNeCancel, buttonModel: { content: this.$t('Topo.cancel') } },
            { click: this.addNeSubmit, buttonModel: { content: this.$t('Topo.confirm'), isPrimary: true } },
          ]
        },
        styles: {
          width: '680px',
          height: '573px',
          zIndex: 1000,
          visible: false,
          model: true
        },
        messages: {
          title: this.$t('Topo.neAdd'),
        },
      },
    };
  },
  methods: {
    sendDeploy() {
      this.$refs.deployCase.saveProfile((response) => {
      this.$parent.$refs.serverData.init(3);
      this.$parent.$refs.deployedData.init(2);
      this.$parent.$parent.$parent.$parent.$parent.getServiceList();
      // this.deployedNum=this.deployedNum+1
      this.deployDialogHide();
      });
    },
    deployDialogHide() {
      this.$refs.deployCasePage.clear();
      this.$refs.deployCasePage.close();
    },
    closeSingleDeploymentPage() {
      this.$refs.singleDeploymentPage.clear();
      this.$refs.singleDeploymentPage.close();
    },
    deployFun() {
      console.log('===================', this.detailInfo);
      let processName = '';
      if (this.detailInfo.deliverTypeId === 2) { // D项目的helm部署方式
        processName = 'mano';
        this.$refs.deployCase.getJson(this.detailInfo);
        this.$refs.deployCasePage.show();
        this.$refs.deployCase.bindValidate();
      } else if (this.detailInfo.deliverTypeId === 1) { // poc微服务
        // 获取需要补充的信息
        processName = 'ems_micropoc';
        this.$refs.singleDeploymentDialog.getEnvironments('DP');

      } else if (this.detailInfo.deliverTypeId === 0) {
        processName = 'ems_micropoc';
        this.$refs.netElementDialog.show();
        this.$refs.netElement.bindValidate();
      }
    },
    deleteFun() {
      this.$layer.confirm({
        msg: `${this.$t('DeployManagement.deletePkg')}`,
        btn1: {
          msg: `${this.$t('Common.cancel')}`
        },
        btn2: {
          msg: `${this.$t('Common.ok')}`,
          func: () => {
            const url = '/lte/ems/packageManager/deletePackage';
            const obj = {};
            obj.oamTypeCode = this.detailInfo.serviceId;
            obj.pkgVersion = this.detailInfo.pkgVersion;
            obj.oamTypeCode = this.detailInfo.oamTypeCode;
            obj.deliverType = this.detailInfo.deliverTypeId;
            this.$loading.showLoadding(this.$t('System.deleteFile'), '');
            this.axios.post(url, obj).then(res => {
              this.$loading.hideLoadding();
              if(res.data.errorCode == 'SUCCESS'){
                EventBus.$emit('toast', {type: 'success', content: this.$t('Common.tips.success')});
              }else{
                EventBus.$emit('toast', {type: 'error', content: res.data.errorString});
              }
              EventBus.$emit('deletePackage',{oamTypeCode : obj.oamTypeCode, deliverType:obj.deliverType});
            });
          }
        }
      });
    },
    addNeSubmit() {
      this.$refs.netElement.outputs();
    },
    addNeCancel() {
      this.$refs.netElementDialog.clear();
      this.$refs.netElementDialog.close();
    },
    updateShowInfo(index=undefined,value=undefined) {
      this.detailShowList[index].value = value;
    }
  }
};
</script>
<style scoped>
  .left-box{
    height:100%;width:240px;background:#fff;border:1px solid #eee;position:relative;
  }
  .left-logo{
    height:92px;width:100%;border-bottom:1px solid #eee;margin-bottom:10px;
    background: url(../../assets/images/logoAmf.png) no-repeat 0 0;
  }
  .word-front{
    font-size:42px;
    position:absolute;
    height:92px;width:100%;
    left:0;
    top:0;
    padding-top:12px;
    color:#1890ff;
    text-align: center;
    z-index: 999;
  }
  .word-behind{
    font-size:42px;
    position:absolute;
    height:92px;width:100%;
    left:0;
    top:0;
    padding-top:15px;
    text-align: center;
    color:#d9f0ff;
    text-indent:3px;
  }
  .left-word{
    width:100%;margin:10px 0;float:left;
  }
  .left-wordName{
    font-size:12px;color:#ccc;width:100%;float:left;text-indent:15px;
  }
  .left-wordContent{
    font-size:14px;color:#333;width:100%;float:left;text-indent:15px;display:inline-block;white-space: nowrap;overflow: hidden!important;text-overflow: ellipsis!important;
  }
  .left-bottom{
    height:62px;width:100%;border-top:1px solid #eee;margin-bottom:0;bottom:0px;position:absolute;padding-left:15px;
  }
</style>
